import React from 'react';

const RssFeedPage = (props) => (
	<div className="container main">
		<h2>RSS 피드</h2>
		<div className="row">
			<div className="col-sm-12">
				<p>제품 리콜에 대한 OECD 글로벌 포털에 게시 된 최신 리콜에 대한 알림을 받으시겠습니까?</p>
				<p>
					<a className={'rss-feed-link'} href={props.config.api + '/rss.xqy'}>RSS 피드를 구독하십시오.</a>
				</p>
				<p>다음과 같은 다양한 방법으로 피드를 구독 할 수도 있습니다.</p>
				<ul className={'rss-feed-options'}>
					<li>RSS 피드의 URL을 뉴스 리더에 복사하십시오.</li>
					<li>RSS 피드의 URL을 브라우저에 복사하십시오.</li>
				</ul>
			</div>
		</div>
	</div>
);

export default RssFeedPage;



// WEBPACK FOOTER //
// ./src/views/static/ko/rss-feed.js